import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import React, { Suspense, lazy } from "react";
import Loader from '../components/Loader';

const LoginPage = lazy(() => import('../pages/auth/Login'));
const ForgotPassword = lazy(() => import('../pages/auth/ForgotPassword'));
const SearchPage = lazy(() => import ('../pages/Search/Search'));
const SearchResultsPage = lazy(() => import ('../pages/Search/SearchResult'));
const PaxDetailsPage = lazy(() => import ('../pages/Checkout/paxDetails'));
const ConfirmationDetailsPage = lazy(() => import ('../pages/Confirmation/Confirmation'));
const RegistrationDetailsPage = lazy(() => import ('../pages/auth/Register'));
const MyTripsPage = lazy(() => import ('../pages/Search/Mytrips'));
const MyProfilePage = lazy(() => import ('../pages/Search/Myprofile'));
const LogoutPage = lazy(() => import ('../pages/auth/Logout'));

function Routes() {
  let authenticated = false;
  try {
    const rawState = localStorage.getItem('persist:access-user');
    if (rawState) {
      const parsedState = JSON.parse(rawState);
      const token = parsedState && parsedState.authToken ? JSON.parse(parsedState.authToken) : "";
      if (token && token.length > 0) {
        authenticated = true;
      }
    }
  } catch(e) {

  }
  
  return (
    <div>
      <Router>
        <div className="container">
          <Suspense fallback={<Loader />}>
            <Switch>
              <Route exact path="/">
                <Redirect to="/search" />
              </Route>
              <Route exact path="/auth/login" component={LoginPage} />
              <Route exact path="/auth/forgot-password" component={ForgotPassword} />
              <Route exact path="/auth/register" component={RegistrationDetailsPage} />
              < Route exact path = "/search" component = {SearchPage} />
              < Route exact path = "/search-results" component = {SearchResultsPage} />
              < Route exact path = "/pax-details" component = {PaxDetailsPage} />
              < Route exact path = "/confirmation-section" component = {ConfirmationDetailsPage} />
              < Route exact path = "/my-trips" component = {MyTripsPage} />
              < Route exact path = "/my-profile" component = {MyProfilePage} />
              < Route exact path = "/logout" component = {LogoutPage} />
            </Switch>
          </Suspense>
        </div>
      </Router>
    </div>
  );
}

export default Routes;